
// console.info( 'process.env: ', process.env );

const config = {
    API_URL: process.env.REACT_APP_API_URL,
    DEBUG_MODE: true
};

export default config;
 